<unity-page-container contentHeader="Disbursements" [contentHeaderSecondary]="$contentHeaderSecondary()" [isLoading]="false">
  <ng-container notifications />

  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>

  <ng-container actions>
    <unity-action-shared [action]="$createDisbursementAction()" />
  </ng-container>

  <unity-grid-disbursement-shared [agreementId]="$agreementId()" />
</unity-page-container>
